import { validateStrEnumValue } from '@mobalytics/shared';
import { useRouteMatch } from 'react-router';
import { PaymentSection } from '../../../types/payment.types';
import { parseAppQueryParams } from '../../../utils/url';
import { useAppStore } from '../../../store/app-store.hook';

export const usePaymentFilters = () => {
  const { params } = useRouteMatch<{ planId?: string; section: string }>();
  const { planId } = params;
  const { productAbbreviation, gameName } = useAppStore().configStore;
  const queryParams = parseAppQueryParams();
  const section = validateStrEnumValue<PaymentSection>(PaymentSection, params.section);
  const couponQueryParam = queryParams.coupon;
  const redirectStatus = queryParams.redirect_status;
  return {
    planId,
    productAbbreviation,
    gameName,
    section,
    couponQueryParam,
    redirectStatus,
  };
};
